/* eslint-disable */
export default class BoundFunctionEqualityMonkeyPatch {
    /**
     * These overrides cause Function.prototype.bind() to return the same function when called with the same arguments.
     * Both overrides must be implemented for this to function properly.
     * 
     * We need to keep this unless we remove or change the compose component.
     * 
     * The Function.prototype.bind() override is used mainly through compose.component.ts.
     * 
     * The Object.is() equality comparison override is used implicitly by angular's change detection.
     * 
     * For example, this makes Object.is(function.bind(this), function.bind(this)) return true,
     * but function.bind(this) === function.bind(this) will still be false because there's no way to override it in JS.
     */
    public static register() {
        var oldFunctionPrototypeBind = Function.prototype.bind;
        Function.prototype.bind = function () {
            if (this[Symbol.for('boundFunction')] !== undefined) {
                return this;
            }

            let result = oldFunctionPrototypeBind.apply(this, arguments);
            result[Symbol.for('boundFunction')] = this;
            result[Symbol.for('boundArguments')] = arguments;
            return result;
        };

        let oldObjectIs = Object.is;
        Object.is = function (value1: any, value2: any) {
            if (value1 && value2 && value1[Symbol.for('boundFunction')] && value2[Symbol.for('boundFunction')]) {
                value1 = value1[Symbol.for('boundFunction')];
                value2 = value2[Symbol.for('boundFunction')];
                let arguments1 = value1[Symbol.for('boundArguments')];
                let arguments2 = value2[Symbol.for('boundArguments')];
                return oldObjectIs(value1, value2) && oldObjectIs(arguments1, arguments2);
            }

            return oldObjectIs(value1, value2);
        };
    }
}
